export default __webpack_public_path__ + "graphics/haute-living.acafeb60.svg";